/**
 * Toast Container Component
 * Displays toast notifications
 */

import React from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';
import { useBOM } from '../contexts/BOMContext';

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useBOM();

  return (
    <>
      {toasts.map((toast, index) => (
        <Snackbar
          key={toast.id}
          open={true}
          autoHideDuration={5000}
          onClose={() => removeToast(toast.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={{ mt: index * 7 }}
        >
          <Alert
            onClose={() => removeToast(toast.id)}
            severity={toast.type as AlertColor}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default ToastContainer;

